import React from "react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import { authRequest } from "lib/constants";

export const withAuth =
  <P extends object>(Component: React.ComponentType<P>): React.FC<P & object> =>
  ({ ...props }: any) =>
    (
      <ErrorBoundary>
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest}>
          <Component {...(props as P)} />
        </MsalAuthenticationTemplate>
      </ErrorBoundary>
    );

export default withAuth;
